var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.5013 10.667C20.7146 10.667 11.168 20.2137 11.168 32.0003C11.168 43.787 20.7146 53.3337 32.5013 53.3337C44.288 53.3337 53.8346 43.787 53.8346 32.0003C53.8346 20.2137 44.288 10.667 32.5013 10.667ZM43.8346 43.067L29.8346 34.667V18.667H33.8346V32.667L45.8346 39.787L43.8346 43.067Z",
    fill: "#98BCDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.472 5.33301C17.752 5.33301 5.83203 17.2797 5.83203 31.9997C5.83203 46.7197 17.752 58.6663 32.472 58.6663C47.2187 58.6663 59.1654 46.7197 59.1654 31.9997C59.1654 17.2797 47.2187 5.33301 32.472 5.33301ZM32.4987 53.333C20.712 53.333 11.1654 43.7863 11.1654 31.9997C11.1654 20.213 20.712 10.6663 32.4987 10.6663C44.2854 10.6663 53.832 20.213 53.832 31.9997C53.832 43.7863 44.2854 53.333 32.4987 53.333ZM33.832 18.6663H29.832V34.6663L43.832 43.0663L45.832 39.7863L33.832 32.6663V18.6663Z",
    fill: "#98BCDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5266d933e4fcb92bb97e21c863aec2a6.svg";
export { ForwardRef as ReactComponent };